import React from 'react';
import Aboutus from '../Components/AboutUsComponent/Aboutus';
import ContactUs from '../Components/ContactUsComponent/ContactUs';
import Imageslider from '../Components/ImageCarousel/Imageslilder';
import { Element } from 'react-scroll';
import JoinUs from '../Components/JoinUsComponent/JoinUs';
import EventSliderComponent from '../Components/EventsSliderComponent/EventSliderComponent';
import LeoMeaning from '../Components/LeoMeaningComponent/LeoMeaning';
import Newsletter from '../Components/NewsletterComponent/Newsletter';

const LandingPageContainer = ({ user }) => {
    return (
        <div className='scroll-container'>

            <Element name='home'>
                <Imageslider viewHeight={'screen-height'} TimeInterval={4000} />
            </Element>

            <Element name='about-us' className='scroll-section'>
                <LeoMeaning />
                <Aboutus />
            </Element>
            <Element name='our-projects' className='scroll-section'>
                <EventSliderComponent />
            </Element>
            <Element name='join-us' className='scroll-section'>
                <JoinUs />
            </Element>
            <Element name='newsletter' className=''>
                <Newsletter />
            </Element>
            <Element name='contact-us' className='scroll-section'>
                <ContactUs user={user} />
            </Element>

        </div>
    );
};

export default LandingPageContainer;
